export let continentsCountries = [
  {
    name: 'Antarctica',
    type: 'continent',
  },
  {
    name: 'Asia',
    type: 'continent',
  },
  {
    name: 'Africa',
    type: 'continent',
  },
  {
    name: 'Oceania',
    type: 'continent',
  },
  {
    name: 'Europe',
    type: 'continent',
  },
  {
    name: 'North America',
    type: 'continent',
  },
  {
    name: 'South America',
    type: 'continent',
  },
  {
    name: 'Afghanistan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Albania',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Algeria',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'American Samoa',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Andorra',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Angola',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Anguilla',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Antigua and Barbuda',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Argentina',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Armenia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Aruba',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Australia',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Austria',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Azerbaijan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Bahamas',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Bahrain',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Bangladesh',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Barbados',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Belarus',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Belgium',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Belize',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Benin',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Bermuda',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Bhutan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Bolivia',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Bosnia and Herzegovina',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Botswana',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Bouvet Island',
    continent: 'Antarctica',
    type: 'country'
  },
  {
    name: 'Brazil',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'British Indian Ocean Territory',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Brunei',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Bulgaria',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Burkina Faso',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Burundi',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Cambodia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Cameroon',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Canada',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Cape Verde',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Cayman Islands',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Central African Republic',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Chad',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Chile',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'China',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Christmas Island',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Cocos (Keeling) Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Colombia',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Comoros',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Congo',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Cook Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Costa Rica',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Croatia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Cuba',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Cyprus',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Czech Republic',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Denmark',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Djibouti',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Dominica',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Dominican Republic',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'East Timor',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Ecuador',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Egypt',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'El Salvador',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'England',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Equatorial Guinea',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Eritrea',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Estonia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Ethiopia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Falkland Islands',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Faroe Islands',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Fiji Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Finland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'France',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'French Guiana',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'French Polynesia',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'French Southern territories',
    continent: 'Antarctica',
    type: 'country'
  },
  {
    name: 'Gabon',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Gambia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Georgia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Germany',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Ghana',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Gibraltar',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Greece',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Greenland',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Grenada',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Guadeloupe',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Guam',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Guatemala',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Guinea',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Guinea-Bissau',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Guyana',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Haiti',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Heard Island and McDonald Islands',
    continent: 'Antarctica',
    type: 'country'
  },
  {
    name: 'Holy See (Vatican City State)',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Honduras',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Hong Kong',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Hungary',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Iceland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'India',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Indonesia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Iran',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Iraq',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Ireland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Israel',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Italy',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Ivory Coast',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Jamaica',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Japan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Jordan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Kazakhstan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Kenya',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Kiribati',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Kuwait',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Kyrgyzstan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Laos',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Latvia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Lebanon',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Lesotho',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Liberia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Libyan Arab Jamahiriya',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Liechtenstein',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Lithuania',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Luxembourg',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Macao',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'North Macedonia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Madagascar',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Malawi',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Malaysia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Maldives',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Mali',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Malta',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Marshall Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Martinique',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Mauritania',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Mauritius',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Mayotte',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Mexico',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Micronesia, Federated States of',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Moldova',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Monaco',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Mongolia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Montenegro',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Montserrat',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Morocco',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Mozambique',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Myanmar',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Namibia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Nauru',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Nepal',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Netherlands',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Netherlands Antilles',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'New Caledonia',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'New Zealand',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Nicaragua',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Niger',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Nigeria',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Niue',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Norfolk Island',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'North Korea',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Northern Ireland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Northern Mariana Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Norway',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Oman',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Pakistan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Palau',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Palestine',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Panama',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Papua New Guinea',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Paraguay',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Peru',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Philippines',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Pitcairn',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Poland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Portugal',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Puerto Rico',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Qatar',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Reunion',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Romania',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Russian Federation',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Rwanda',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Saint Helena',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Saint Kitts and Nevis',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Saint Lucia',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Saint Pierre and Miquelon',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Samoa',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'San Marino',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Sao Tome and Principe',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Saudi Arabia',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Scotland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Senegal',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Serbia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Seychelles',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Sierra Leone',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Singapore',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Slovakia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Slovenia',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Solomon Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Somalia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'South Africa',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    continent: 'Antarctica',
    type: 'country'
  },
  {
    name: 'South Korea',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'South Sudan',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Spain',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Sri Lanka',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Sudan',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Suriname',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Svalbard and Jan Mayen',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Swaziland',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Sweden',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Switzerland',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Syria',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Tajikistan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Tanzania',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Thailand',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'The Democratic Republic of Congo',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Togo',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Tokelau',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Tonga',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Trinidad and Tobago',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Tunisia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Turkey',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Turkmenistan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Turks and Caicos Islands',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Tuvalu',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Uganda',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Ukraine',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'United Arab Emirates',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'United Kingdom',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'United States',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'United States Minor Outlying Islands',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Uruguay',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Uzbekistan',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Vanuatu',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Venezuela',
    continent: 'South America',
    type: 'country'
  },
  {
    name: 'Vietnam',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Virgin Islands, British',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Virgin Islands, U.S.',
    continent: 'North America',
    type: 'country'
  },
  {
    name: 'Wales',
    continent: 'Europe',
    type: 'country'
  },
  {
    name: 'Wallis and Futuna',
    continent: 'Oceania',
    type: 'country'
  },
  {
    name: 'Western Sahara',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Yemen',
    continent: 'Asia',
    type: 'country'
  },
  {
    name: 'Zambia',
    continent: 'Africa',
    type: 'country'
  },
  {
    name: 'Zimbabwe',
    continent: 'Africa',
    type: 'country'
  },
];

export let expertises = []